// libs
import { connect } from 'react-redux';

// components
import ImageRail from './ImageRail';

// store
import {
  getAllReviewImages,
  isReviewImagesFetching,
  isReviewImagesFetchingError,
  getTotalReviewImages,
} from 'shared/store/details/selectors';

const mapStateToProps = (state: any) => {
  return {
    imageList: getAllReviewImages(state),
    isFetching: isReviewImagesFetching(state),
    isError: isReviewImagesFetchingError(state),
    totalCount: getTotalReviewImages(state),
  };
};

export default connect(mapStateToProps)(ImageRail);
